<template>
  <div className="animated">
    <b-row class="my-2">
      <b-col>
        <h1 class="text-uppercase font-weight-bold">Listado de Inspecciones</h1>
      </b-col>
    </b-row>
    <server-filterable-table
      :downloadeable="false"
      :column_display="column_display"
      :columns="columns"
      :filterable="filterable"
      :headings="headings"
      :listColumns="listColumns"
      :url="url"
      :clickable="true"
      :action-buttons="action_buttons"
      @on-loading="loading = $event"
      @on-link-action="goToExternalLink"
    >
    </server-filterable-table>
  </div>
</template>

<script>
import ServerFilterableTable from "@/bagno_views/ServerFilterableTable";

export default {
  name: "InspectionList",
  components: {
    ServerFilterableTable
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      items: [],
      selectedItems: [],
      url: "/api/qc/inspection/",
      title: "Listado de Inspecciones",
      loading: false,
      action_buttons: ["link"],
      columns: ["external_id", "name", "score", "pallet_number", "grower", "variety", "created_at", "actions"],
      filterable: ["name", "grower", "variety", "data._L_Name_Product", "pallet_number", "external_id"],
      headings: {
        actions: "",
        external_id: "ID Externo",
        name: "Nombre",
        score: "Puntaje",
        pallet_number: "Pallet",
        created_at: "Synced At",
        grower: "Productor",
        variety: "Variedad",
        "data._L_Name_Product": "Tipo"
      },
      listColumns: {}
    };
  },
  methods: {
    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Inspeccion #" + a + ".pdf"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    downloadWithAxios(item, id) {
      this.loading = true;
      this.$axios({
        method: "get",
        url: `${this.baseUrl}/api/v1/qc/download_pallet_pdf/${item.id}/`,
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.loading = false;
          this.forceFileDownload(response, id);
        })
        .catch(() => {
          console.log("error occured");
          // Toast error
          this.$bvToast.toast("Error al descargar el archivo", {
            title: "Error",
            variant: "danger",
            solid: true
          });
          this.loading = false;
        });
    },
    goToExternalLink(item) {
      const ID_CLIENTE = this.$store.state.user.ID_CLIENTE;
      if (ID_CLIENTE === 4) {
        window.open(item.data._L_Link_Web, "_blank");
      } else if (ID_CLIENTE === 15) {
        {
          this.downloadWithAxios(item, item.id);
        }
      }
    },

    debug(eve) {
      console.log(eve);
    }
  }
};
</script>

<style></style>
